import { useCallback, useEffect, useState } from 'react'
import { seriesApi } from '../lib/api.js'
import type { Series } from '../types/domain.js'

/**
 * Séries de la chaîne, épisodes inclus.
 *
 * Le panneau latéral garde sa propre requête (elle porte la recherche saisie) ;
 * ce hook sert l'écran central, qui affiche toujours le catalogue complet.
 */
export function useSeriesCatalog(channelId: string | null | undefined, refreshKey: unknown) {
  const [series,  setSeries]  = useState<Series[]>([])
  const [loading, setLoading] = useState(true)
  const [seq,     setSeq]     = useState(0)

  const reload = useCallback(() => setSeq(value => value + 1), [])

  useEffect(() => {
    if (!channelId) {
      setSeries([])
      setLoading(false)
      return
    }
    let cancelled = false
    setLoading(true)
    seriesApi.list({ channelId })
      .then(list => { if (!cancelled) setSeries(list) })
      .catch(() => { if (!cancelled) setSeries([]) })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [channelId, refreshKey, seq])

  return { series, loading, reload }
}
